import React, { useEffect, useState } from 'react';
import { Button, Loader } from 'freemium-ui';
import axios from 'axios';
import ReactDOM from 'react-dom';
import { Trans } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Icon from 'shared/components/Icon';
import { Center } from 'shared/styles';
import config from '../../../utils/config';
import i18n from '../../../i18n';
import { UnsubscribeContainer } from './style';

const useQueryParams = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};
const Unsubscribe = () => {
  const [state, setState] = useState<
    'unsubscribing' | 'unsubscribed' | 'reSubscribed'
  >('unsubscribing');
  const [account, setAccount] = useState<any>();
  const query: any = useQueryParams();
  const accountId = query.get('account_id');
  const contactId = query.get('contact_id');
  const surveyId = query.get('survey_id') || query.get('sid');
  const test = query.get('test');
  const [submitState, setSubmitState] = useState<
    'submitting' | 'failed' | 'idle'
  >('idle');
  useEffect(() => {
    (async () => {
      try {
        const response = await axios({
          url: `${config.PUBLIC_API_URL}/public-api/v1/public/account/${accountId}`,
          headers: {
            'Content-Type': 'application/json',
          },
        });
        setAccount(response?.data?.account_meta);
      } catch (error: any) {
        console.error(error);
      }
    })();
  }, []);
  const handleSubscription = async (is_unsubscribing) => {
    setSubmitState('submitting');
    if (contactId !== 'test') {
      try {
        await axios({
          url: is_unsubscribing
            ? `${config.PUBLIC_API_URL}/public-api/v1/public/account/${accountId}/contact/${contactId}/survey/${surveyId}/subscribe`
            : `${config.PUBLIC_API_URL}/public-api/v1/public/account/${accountId}/contact/${contactId}/subscribe`,
          method: is_unsubscribing ? 'DELETE' : 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        setSubmitState('idle');
        setState(is_unsubscribing ? 'unsubscribed' : 'reSubscribed');
      } catch (error: any) {
        setSubmitState('failed');
      }
    }
  };

  if (!account) {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }

  return (
    <UnsubscribeContainer>
      {ReactDOM.createPortal(
        <link rel="icon" href={account?.favicon_url} />,
        document.head,
      )}
      <div className="u-company-icon">
        {account?.logo_url ? (
          <div className="logo">
            <img src={account?.logo_url} alt="Company logo" className="logo" />
          </div>
        ) : (
          <h2 className="company-name">{account?.company_name}</h2>
        )}
      </div>
      {test ? (
        <div className="u-container">
          <div className="u-heading">{i18n.t('unsubscribe.heading')}</div>
          <div className="u-description">
            <Trans
              i18nKey="unsubscribe.desc"
              values={{
                company_name: account?.company_name,
              }}
              components={{ bold: <b /> }}
            />
          </div>
        </div>
      ) : (
        <>
          {state === 'reSubscribed' && (
            <div className="u-container">
              <div className="u-heading">{i18n.t('unsubscribe.welcome')}</div>
              <div className="u-description">
                {i18n.t('unsubscribe.receive_email')}
              </div>
            </div>
          )}
          {state === 'unsubscribed' && (
            <div className="u-container">
              <div className="u-icon">
                <Icon
                  glyph="green-tick"
                  width="55"
                  height="55"
                  viewBox="0 0 55 55"
                />
              </div>
              <div className="u-heading">
                {i18n.t('unsubscribe.unsubscribed')}
              </div>
              <div className="u-description">
                {i18n.t('unsubscribe.no_longer_receive_email')}
              </div>
              <div className="u-footer">
                <div>{i18n.t('unsubscribe.footer')}&nbsp;</div>
                <div
                  className="link"
                  onClick={() => {
                    if (submitState === 'submitting') return;
                    handleSubscription(false);
                  }}
                >
                  {i18n.t('unsubscribe.subscribe_again')}
                </div>
              </div>
            </div>
          )}
          {state === 'unsubscribing' && (
            <div className="u-container">
              <div className="u-icon">
                <Icon
                  width="81"
                  height="90"
                  viewBox="0 0 81 90"
                  glyph="unsubscribe"
                />
              </div>
              <div className="u-heading">
                {i18n.t('unsubscribe.unsubscribe_from_survey')}
              </div>
              <div className="u-description">
                {i18n.t('unsubscribe.is_confirm_unsubscribe')}
              </div>
              <div className="u-action">
                <Button
                  inline
                  className="confirm-button"
                  onClick={() => handleSubscription(true)}
                  disabled={submitState === 'submitting'}
                >
                  {submitState === 'failed'
                    ? `${i18n.t('try_again')}`
                    : `${i18n.t('confirm')}`}
                </Button>
              </div>
            </div>
          )}
        </>
      )}
      <div className="spacer" />
      <footer>
        <span>
          <Trans
            i18nKey="online_survey_powered_by"
            components={{
              a: (
                <a
                  href="https://www.freshworks.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
            }}
          />
        </span>
        <a
          href="https://www.freshworks.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="logo-link"
        >
          <Icon glyph="freshworks" width="91" height="19" viewBox="0 0 91 19" />
        </a>
      </footer>
    </UnsubscribeContainer>
  );
};

export default Unsubscribe;
